const postResponseMapper = (data) => {
  console.log(data)
  return {
    error: data?.error ?? false,
    message: data?.message ?? '',
    variant: data?.variant ?? 'error',
    url: data?.url ?? '',
    data: data?.data ?? []
  }
}

const generalMapper = {
  postResponseMapper
}

export default generalMapper
